module.exports = __webpack_public_path__ + "img/thermofisher-logo.dd7c6f6c.jpg";